import { render, staticRenderFns } from "./inputNumber.vue?vue&type=template&id=b3675340&scoped=true"
import script from "./inputNumber.vue?vue&type=script&lang=js"
export * from "./inputNumber.vue?vue&type=script&lang=js"
import style0 from "./inputNumber.vue?vue&type=style&index=0&id=b3675340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3675340",
  null
  
)

component.options.__file = "inputNumber.vue"
export default component.exports